var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8OpenDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5 3 C 4.448 3 4 3.448 4 4 L 4 19 L 3 19 C 2.448 19 2 19.448 2 20 C 2 20.552 2.448 21 3 21 L 7 21 L 14 21 C 14.552 21 15 20.552 15 20 L 15 6 L 18 6 L 18 21 L 21 21 C 21.552 21 22 20.552 22 20 C 22 19.448 21.552 19 21 19 L 20 19 L 20 5 C 20 4.448 19.552 4 19 4 L 15 4 C 15 3.448 14.552 3 14 3 L 5 3 z M 11.5 11 L 12.5 11 C 12.776 11 13 11.224 13 11.5 L 13 12.5 C 13 12.776 12.776 13 12.5 13 L 11.5 13 C 11.224 13 11 12.776 11 12.5 L 11 11.5 C 11 11.224 11.224 11 11.5 11 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8OpenDoor);
export default __webpack_public_path__ + "static/media/icons8-open-door.54f86243.svg";
export { ForwardRef as ReactComponent };